var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountsActive = function SvgAccountsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.786 4.438A10.78 10.78 0 1 0 23.56 15.214H12.786V4.438Z",
    fill: "#D1B896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.786 3.114v12.1h12.1A1.115 1.115 0 0 0 25.996 14 13.27 13.27 0 0 0 14 2.004a1.114 1.114 0 0 0-1.214 1.11Z",
    fill: "#DAC6AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.786 25.995a10.78 10.78 0 0 0 10.775-10.78H12.786v10.78Z",
    fill: "#A79378"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.028 14.55a.454.454 0 0 1-.44-.3.45.45 0 0 1 .415-.595.44.44 0 0 1 .354.175.655.655 0 0 0 .5.27h.08a.64.64 0 0 0 .55-1 1.84 1.84 0 0 0-.65-.59.34.34 0 0 1-.175-.29.67.67 0 0 0-.66-.65.67.67 0 0 0-.67.67.32.32 0 0 1-.17.285 1.784 1.784 0 0 0 .84 3.36.444.444 0 1 1-.145.865.46.46 0 0 1-.224-.161.6.6 0 0 0-.5-.26h-.08a.66.66 0 0 0-.53 1.05c.164.207.37.378.605.5a.32.32 0 0 1 .17.284.67.67 0 0 0 .705.7.67.67 0 0 0 .67-.67.32.32 0 0 1 .17-.285 1.784 1.784 0 0 0-.815-3.358Z",
    fill: "#EDE3D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.995 14a13.225 13.225 0 0 0-3.828-8.157l-9.381 9.371h12.1A1.115 1.115 0 0 0 25.996 14Z",
    fill: "#E3D4C0"
  })));
};
export default SvgAccountsActive;